import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
  inject,
  signal,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  BottomSheetComponent,
  DeviceService,
  TabsInkbarFixDirective,
} from '@nomoh-monorepo/shared-common-ui';
import { IProfissional } from '@nomoh-monorepo/shared-types';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { TabsModule } from 'primeng/tabs';
import { TooltipModule } from 'primeng/tooltip';
import { BardoContextDataService, NichoTermosService } from '@nomoh-monorepo/data-access-bardo-administrador';
import { TranslateModule } from '@ngx-translate/core';
import { ProfissionalAusenciasComponent } from './profissional-ausencias/profissional-ausencias.component';

import { ProfissionalCreateEditComponent } from './profissional-create-edit/profissional-create-edit.component';
import { ProfissionalInfoComponent } from './profissional-info/profissional-info.component';
@Component({
  selector: 'lib-profissional-view-modal',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    TooltipModule,
    ReactiveFormsModule,
    MultiSelectModule,
    BottomSheetComponent,
    ProfissionalInfoComponent,
    TabsModule,
    TabsInkbarFixDirective,
    ProfissionalCreateEditComponent,
    ProfissionalAusenciasComponent,
    TranslateModule,
  ],
  templateUrl: './profissional-view-modal.component.html',
  styleUrls: ['./profissional-view-modal.component.scss'],
})
export class ProfissionalViewModalComponent implements OnChanges {
  //#region Inputs e Outputs
  @Input() visible = false;
  @Input() profissional: IProfissional | null = null;

  @Output() closed = new EventEmitter<void>();

  //#endregion
  //#region Injeção de Dependências

  deviceService = inject(DeviceService);
  private contextoService = inject(BardoContextDataService);
  $nicho = inject(NichoTermosService).$nicho;

  //#endregion
  
  possuiPermissao(permissao: string) {
    return this.contextoService.possuiPermissao(permissao);
  }

  //#region Signals
  modalFechamentoAberto = signal(false);
  activeTab = signal<string>('view');
  $internalVisible = signal(false);
  resetKey = signal(0);
  //#endregion

  footerTemplate: TemplateRef<unknown> | null = null;

  tabs = [
    { id: 'view', labelKey: 'BARDO_PROFISSIONAIS.TABS.VIEW', label: 'Visualizar', icon: 'pi pi-eye' },
    { id: 'editar', labelKey: 'BARDO_PROFISSIONAIS.TABS.EDITAR', label: 'Editar', icon: 'pi pi-pencil' },
    { id: 'ausencias', labelKey: 'BARDO_PROFISSIONAIS.TABS.AUSENCIAS', label: 'Ausências', icon: 'pi pi-calendar-times' },
    { id: 'criar', labelKey: 'BARDO_PROFISSIONAIS.TABS.CRIAR', label: 'Criar', icon: 'pi pi-plus' },
  ];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['visible']) {
      this.$internalVisible.set(this.visible);
    }
    if (changes['visible']?.currentValue === true) {
      this.activeTab.set(this.profissional === null ? 'criar' : 'view');
      if (this.profissional === null) {
        this.resetKey.update((current) => current + 1);
      }
    }
  }

  tabVisivel(tabId: string): boolean {
    if (tabId === 'criar') return this.profissional === null && this.possuiPermissao('Bardo.profissionais.create');
    if (tabId === 'editar') return this.profissional !== null && this.possuiPermissao('Bardo.profissionais.update');
    if (tabId === 'ausencias') return this.profissional !== null && this.possuiPermissao('Bardo.profissionais.update');
    return this.profissional !== null;
  }

  onTabChange(tabId: string) {
    this.activeTab.set(tabId);
    this.resetFooterTemplate();
    if (tabId === 'criar') {
      this.resetKey.update((current) => current + 1);
    }
  }

  fechar() {
    this.$internalVisible.set(false);
    this.resetFooterTemplate();
    this.closed.emit();
  }

  abrirModalFechamento() {
    this.modalFechamentoAberto.set(true);
  }
  fecharAbaCriarEditar() {
    this.fechar();
  }

  footerTemplateAction(template: TemplateRef<unknown>): void {
    this.footerTemplate = template;
  }

  resetFooterTemplate(): void {
    this.footerTemplate = null;
  }
}
